import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer, useState } from "react";
import dayjs from "dayjs";
import { channelConstants } from "./dashboard.constants";
/**
 * @typedef {Object} DashboardState
 * @description Shape of the reducer state. Extend as needed.
 * @property {any} [key] - Example placeholder property
 */
/**
 * @typedef {Object} DashboardAction
 * @property {string} type - Action type
 * @property {any} [payload] - Optional action payload
 */
/**
 * @typedef {Object} DashboardContextType
 * @property {DashboardState} state - Current reducer state
 * @property {React.Dispatch<DashboardAction>} dispatch - Reducer dispatch function
 * @property {string} startDateForAPI - Start date string for API in ISO format
 * @property {function(string):void} setStartDateForAPI - Setter for startDateForAPI
 * @property {string} endDateForAPI - End date string for API in ISO format
 * @property {function(string):void} setEndDateForAPI - Setter for endDateForAPI
 * @property {string} selectedChannel - selected channel
 * @property {function(string):void} setSelectedChannel - setter for selectedChannel
 */
const DashboardContext = createContext(
/** @type {DashboardContextType | undefined} */ (undefined));
/**
 * @typedef {Object} DashboardProviderProps
 * @property {React.ReactNode} children - React child nodes
 */
/**
 * Reducer function for DashboardContext
 * @param {DashboardState} state - Current state
 * @param {DashboardAction} action - Action object
 * @returns {DashboardState} Updated state
 */
const reducer = (state, action) => {
    switch (action.type) {
        default:
            return state;
    }
};
/**
 * Dashboard Context Provider
 *
 * @param {DashboardProviderProps} props - Provider props
 * @returns {JSX.Element} Dashboard context provider wrapper
 */
export function DashboardContextProvider({ children }) {
    const initialState = {};
    const [state, dispatch] = useReducer(reducer, initialState);
    const [startDateForAPI, setStartDateForAPI] = useState(dayjs(new Date()).format("YYYY-MM-DD") + "T00:00:00.000Z");
    const [endDateForAPI, setEndDateForAPI] = useState(dayjs(new Date()).format("YYYY-MM-DD") + "T23:59:59.999Z");
    const [selectedChannel, setSelectedChannel] = useState(channelConstants.ALL_CHANNEL
    // channelConstants.SMS
    );
    const values = {
        state,
        dispatch,
        startDateForAPI,
        setStartDateForAPI,
        endDateForAPI,
        setEndDateForAPI,
        selectedChannel,
        setSelectedChannel,
    };
    return (_jsx(DashboardContext.Provider, { value: values, children: children }));
}
/**
 * Hook to use Dashboard context
 *
 * @returns {DashboardContextType} Dashboard context values
 * @throws {Error} If used outside DashboardContextProvider
 */
export const useDashboardContext = () => {
    const context = useContext(DashboardContext);
    if (!context) {
        throw new Error("Dashboard context must be used within DashboardContextProvider");
    }
    return context;
};
